import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { StoreEntryPrompt } from "#/app/store-entry-prompt";
import { startApiMocks } from "#/mocks";
import { createAppRouter } from "#/router";
import { boundShopDomain } from "#/shared/lib/bound-store";
import { applyStoredTheme } from "#/shared/lib/theme";

import "./styles.css";

applyStoredTheme();

const rootElement = document.getElementById("root");

if (rootElement === null) {
  throw new Error("找不到 #root 挂载点。");
}

await startApiMocks();

createRoot(rootElement).render(
  <StrictMode>
    {boundShopDomain() === null ? (
      <StoreEntryPrompt />
    ) : (
      <RouterProvider router={createAppRouter()} />
    )}
  </StrictMode>,
);
